import { APICfg } from 'services/api/api'
import { mainProductParse, mainProductWrite } from '../mainProduct'
import { drinkVariantParse, drinkVariantWrite } from './drinkVariant'
import { DrinkToAPI } from './types/api/request-models'
import { APIDrink } from './types/api/response-models'
import { Drink } from './types/internal/drink-models'

// ============
// PARSE
// ============

const drinkParse = (res: APIDrink): Drink => ({
  ...res,
  ...mainProductParse(res),
  hasMultipleVariants: res.variants.length > 1,
  variants: res.variants.map(drinkVariantParse),
})

// ============
// WRITE
// ============

const drinkWrite = async ({
  variants,
  drinksPerUnit,
  minQuantity,
  ...req
}: Drink): Promise<DrinkToAPI> => ({
  ...(await mainProductWrite(req)),
  variants: await Promise.all(variants.map(drinkVariantWrite)),
  drinksPerUnit,
  minQuantity,
})

// ============
// CFG
// ============

const apiCfg: APICfg = {
  endpoint: 'drink',
  parse: drinkParse,
  write: drinkWrite,
}

export default apiCfg
